import React from "react";
import { github, linkedin, sketchfab, email } from "../assets";

const Contact = () => {
    return <section id="contact">
        <h2 className="underline-title">Contact</h2>
        <div className="contact-container">
            <div className="contact-link">
                <img src={github.src} alt={github.alt} />
                <a href="https://github.com/PopaBiancaStefana" target="_blank" rel="noopener noreferrer">
                    <h4>GitHub</h4>
                </a>
            </div>

            <div className="contact-link">
                <img src={linkedin.src} alt={linkedin.alt} />
                <a href="https://www.linkedin.com/in/bianca-stefana-popa/" target="_blank" rel="noopener noreferrer">
                    <h4>LinkedIn</h4>
                </a>
            </div>

            <div className="contact-link">
                <img src={sketchfab.src} alt={sketchfab.alt} />
                <a href="https://sketchfab.com/Bianca.Popa" target="_blank" rel="noopener noreferrer">
                    <h4>Sketchfab</h4>
                </a>
            </div>

            <div className="contact-link">
                <img src={email.src} alt={email.alt} />
                <h4>popabianca945@yahoo.com</h4>
            </div>


        </div>
    </section>;
};

export default Contact;